<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9376 19.8332C25.3851 19.8332 28.9905 16.2888 28.9905 11.9166C28.9905 7.54438 25.3851 4 20.9376 4C16.4902 4 12.8848 7.54438 12.8848 11.9166C12.8848 16.2888 16.4902 19.8332 20.9376 19.8332Z"
      fill="#E7EEF1"
    />
    <path
      d="M28.5308 21.6427C28.5446 21.1225 28.7471 19.1547 27.431 18.838C27.316 18.6254 26.8236 17.5759 26.4048 16.6802C26.0183 15.8478 25.1716 15.3094 24.2375 15.3094H20.708V23.9046H28.3467C28.3467 23.9046 28.991 23.4748 28.991 22.9999C28.991 22.5249 29.106 21.792 28.5308 21.6427Z"
      fill="#6BFFFF"
    />
    <path
      d="M20.708 23.9046H28.3467C28.3467 23.9046 28.991 23.4748 28.991 22.9999C28.991 22.5249 29.106 21.792 28.5308 21.6427C28.5446 21.1225 28.7471 19.1547 27.431 18.838C27.316 18.6254 26.8236 17.5759 26.4048 16.6802C26.0183 15.8478 25.1716 15.3094 24.2375 15.3094H20.708"
      stroke="#011837"
      stroke-miterlimit="10"
    />
    <path
      d="M25.3178 18.8877L24.5631 17.3044C24.5079 17.1868 24.3882 17.1144 24.2594 17.1144H22.543V19.3763H24.9956C25.2533 19.3763 25.4236 19.1139 25.3132 18.8832L25.3178 18.8877Z"
      fill="white"
      stroke="#011837"
      stroke-miterlimit="10"
    />
    <path
      d="M5.98242 11.2379V14.8569V19.8331V23.9045H20.7077V11.2379H5.98242Z"
      fill="white"
    />
    <path
      d="M5.98242 14.8569V11.2379H20.7077V23.9045H5.98242V19.8331"
      stroke="#011837"
      stroke-miterlimit="10"
    />
    <path
      d="M5.98242 18.9284V16.2141"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M11.9684 23.9C11.9684 24.8952 11.1447 25.7049 10.1278 25.7049C9.1108 25.7049 8.28711 24.8952 8.28711 23.9C8.28711 22.9047 9.1108 22.095 10.1278 22.095C11.1447 22.095 11.9684 22.9047 11.9684 23.9Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-miterlimit="10"
    />
    <path
      d="M25.7741 23.9C25.7741 24.8952 24.9504 25.7049 23.9334 25.7049C22.9165 25.7049 22.0928 24.8952 22.0928 23.9C22.0928 22.9047 22.9165 22.095 23.9334 22.095C24.9504 22.095 25.7741 22.9047 25.7741 23.9Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-miterlimit="10"
    />
    <path d="M10.5839 18.476H1.84082" stroke="#011837" stroke-miterlimit="10" />
    <path d="M15.6457 14.8571H4.1416" stroke="#011837" stroke-miterlimit="10" />
    <path d="M18.4067 11.2379H4.1416" stroke="#011837" stroke-miterlimit="10" />
    <path
      d="M3.22111 11.2379H2.30078"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M1.38127 11.2379H0.460938"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M0.920328 18.476H0"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M3.22111 14.8571H2.30078"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>
